import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';

export enum STORAGE_CLUSTER_STATUSES {
  HEALTHY = 'healthy',
  DEGRADED = 'degraded',
  UNAVAILABLE = 'unavailable',
  WARNING = 'warning',
  ERROR = 'error',
  UNKNOWN = 'unknown'
}

export const CLUSTER_STATUSES_TYPES_MAP = {
  [STORAGE_CLUSTER_STATUSES.HEALTHY]: 'success',
  [STORAGE_CLUSTER_STATUSES.DEGRADED]: 'danger',
  [STORAGE_CLUSTER_STATUSES.UNAVAILABLE]: 'danger',
  [STORAGE_CLUSTER_STATUSES.WARNING]: 'warning',
  [STORAGE_CLUSTER_STATUSES.ERROR]: 'danger',
  [STORAGE_CLUSTER_STATUSES.UNKNOWN]: 'portal'
};

// conflict with endpoint names
export const DISALLOWED_STORAGE_CLUSTER_NAMES = ['disks'];

type StorageClusterStatusesText = Record<STORAGE_CLUSTER_STATUSES, string>;

export const STORAGE_CLUSTER_STATUSES_TEXT = computedLocale<StorageClusterStatusesText>(() => ({
  [STORAGE_CLUSTER_STATUSES.HEALTHY]: i18n.t('Healthy'),
  [STORAGE_CLUSTER_STATUSES.DEGRADED]: i18n.t('Degraded'),
  [STORAGE_CLUSTER_STATUSES.UNAVAILABLE]: i18n.t('Unavailable'),
  [STORAGE_CLUSTER_STATUSES.WARNING]: i18n.t('Warning'),
  [STORAGE_CLUSTER_STATUSES.ERROR]: i18n.t('Error'),
  [STORAGE_CLUSTER_STATUSES.UNKNOWN]: i18n.t('Unknown')
}));
